import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { EleicaoService } from 'src/app/services/eleicao.service'
import { BlacklistCandidaturaService } from 'src/app/services/blacklistcandidatura.service'

import { Utils } from 'src/app/utils/utils';
import { ActivatedRoute } from '@angular/router';
import { CandidaturaService } from 'src/app/services/candidatura.service';
import { BlacklistCandidaturaCsvDTO } from 'src/app/models/blacklistCandidaturaCsvDTO.model';

@Component({
  selector: 'cadastro-blacklistpre',
  templateUrl: './blacklistprecandidato.component.html',
  styleUrls: ['./blacklistprecandidato.component.css']
})
export class BlacklistPreCandidatoComponent implements OnInit {
  public newBlacklistArray: BlacklistCandidaturaCsvDTO[] = [];

  formCadastroBlacklistsPreCandidatos: FormGroup;
  idEleicao: any;
  idCandidatura: any;
  token: any;
  listaBlacklist: any;
  novoLoginBlacklistCandidatura:  BlacklistCandidaturaCsvDTO = new BlacklistCandidaturaCsvDTO();
  newBlacklistDTO: BlacklistCandidaturaCsvDTO= new BlacklistCandidaturaCsvDTO();

  constructor(
    public router: ActivatedRoute,
    public eleicaoService: EleicaoService,
    public blacklistCandidaturaService: BlacklistCandidaturaService,
    public utils: Utils,
    protected messageService: MessageService,
    protected candidaturaService: CandidaturaService
  ) { }

  async ngOnInit() {
    
    this.idEleicao = JSON.parse(sessionStorage.getItem("eleicaoClicadaParametrizacao")).id;
    this.token = sessionStorage.getItem("token");
    this.formCadastroBlacklistsPreCandidatos = new FormGroup({
      login: new FormControl(),
    });
    if(sessionStorage.getItem("temCandidaturas")){
      await this.listarDadosExistentes();
      await this.dadosBlackListPreCandidatos(); 
    }
  }
   dadosBlackListPreCandidatos(){
    this.blacklistCandidaturaService.getBlackListByCandidaturaId(this.token, this.idCandidatura).then((res: []) => {
      if (res.length > 0) {
        this.listaBlacklist = res;
      } else {   
      }
    })
  }

  public atualizaLoginNaBlacklist(login, loginId) {
    this.blacklistCandidaturaService.atualizaLoginNaBlacklist(this.token, login, loginId).then(data => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Login atualizado na blacklist com sucesso!' });
      this.formCadastroBlacklistsPreCandidatos.reset();
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      this.formCadastroBlacklistsPreCandidatos.reset();

    })
  }

  async listarDadosExistentes(){
    await this.candidaturaService.listarPorIdEleicao(this.idEleicao, this.token).then((data: any) => {
        this.idCandidatura = data.id;
            }, err => {
        console.log(err);
      })
    }

  // public inserirLoginsNaBlackListEmMassa(event: any) {
  //   let csvFilePath = event.target.value
  //   this.blacklistService.inserirLoginsNaBlackListEmMassa(this.token, listaLogin).then(() => {
  //     this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Blacklist inserida com sucesso!' });
  //     setTimeout(function () {
  //       window.location.reload();
  //     })
  //   }, error => {
  //     this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
  //   })
  // }

  public envioLoginBlacklistCandidatura() {
    if (this.validarCampoBlackList()) {
      this.novoLoginBlacklistCandidatura.login = this.formCadastroBlacklistsPreCandidatos.get("login").value;
      this.novoLoginBlacklistCandidatura.candidaturaId = this.idCandidatura;

      this.blacklistCandidaturaService.inserirLoginNaBlacklist(this.token, this.novoLoginBlacklistCandidatura).then(data => {
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Login inserido na blacklist com sucesso!' });
        setTimeout(function () {
          window.location.reload();
        })
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
      })
    }
  }

  public excluirDaBlacklist(blacklistId) {
    this.blacklistCandidaturaService.deletaLoginNaBlacklist(this.token, blacklistId).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Login excluído na blacklist com sucesso!' });
      setTimeout(function () {
        window.location.reload();
      })
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: error + '.' });
    })
  }

  baixarTemplate() {
    let csvHeader = 'logins'
    this.utils.baixarModeloCsv(csvHeader, "blacklist")
  }

  // CSV
  importarCsv(event) {

    let arquivos = event.srcElement.files;

    if (this.validaTipoArquivo(arquivos[0])) {
      let input = event.target;
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);

      fileReader.onload = () => {
        let csvData = fileReader.result;
        let csvRecordsArray = csvData.toString().split(/\r\n|\n/);
        let headersRow = this.utils.getHeaderArray(csvRecordsArray);
        this.newBlacklistArray = this.getDataRecordsArrayFromCSVFile(csvRecordsArray, headersRow.length);
      };
    }
  }

  validaTipoArquivo(file: any) {
    return file.name.endsWith(".csv");
  }

  getDataRecordsArrayFromCSVFile(csvRecordsArray: any, headerLength: any) {
    let csvArr = [];

    for (let i = 1; i < csvRecordsArray.length; i++) {
      let currentRecord = csvRecordsArray[i];
      if (currentRecord.length != 0) {
        let csv: BlacklistCandidaturaCsvDTO = new BlacklistCandidaturaCsvDTO();
        csv.login = currentRecord;
        csv.candidaturaId = this.idCandidatura;
        csvArr.push(csv);
      }
    }
    return csvArr
  }
  private async insercaoEmMassa(blacklist: BlacklistCandidaturaCsvDTO[]) {
    await this.blacklistCandidaturaService.inserirLoginsNaBlackListEmMassa(this.token, blacklist).then(() => {
      this.messageService.add({ key: 'toast', severity: 'success', summary: 'Sucesso!', detail: 'Blacklist enviada com sucesso!' });
      setTimeout(function () {
        window.location.reload();
      })
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: '', detail: error });
    });
  }
  validarCampoBlackList() {
    if (this.formCadastroBlacklistsPreCandidatos.get("login").value == null || this.formCadastroBlacklistsPreCandidatos.get("login").value == '') {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Ops!', detail: 'É necessário informar o login para a blacklist.' });
      return false;
    } else {
      return true;
    }
  }

  zerarInputFile(element) {
    this.newBlacklistArray = [];
    element.value = '';
  }
  importarList() {
    this.insercaoEmMassa(this.newBlacklistArray);
  }
}


